import LauncherGenerator from './LauncherGenerator';

export default class LauncherGeneratorAotWorker extends LauncherGenerator {

    constructor(workerPath) {
        super();

        const workerURL = `${process.env.PUBLIC_URL}/${workerPath}`;
        this.workerPromise = this.createWorkerPromise(workerURL);
    }

    async createWorkerPromise(workerURL) {
        const worker = new Worker(workerURL);

        return new Promise((resolve, reject) => {
            let listener;
            listener = (e) => {
                if (e.data.initialized) {
                    if (e.data.error) {
                        reject(e.data.error);
                    } else {
                        resolve(worker);
                    }
                    worker.removeEventListener('message', listener);
                }
            };
            worker.addEventListener('message', listener);
        });
    }

    /*
     * Overridden method
     */
    async getInitializationPromise() {
        await this.workerPromise;
        return true;
    }

    async postCommandToWorker(worker, commandName, args) {
        const commandPromise = new Promise((resolve, reject) => {
            let workerListener;
            workerListener = (event) => {
                if (event.data.command === commandName) {
                    if (event.data.error) {
                        reject(event.data.error);
                    } else {
                        resolve(event.data.content);
                    }
                    worker.removeEventListener("message", workerListener);
                }
            };
            worker.addEventListener("message", workerListener);
        });
        worker.postMessage({ command: commandName, arguments: args });

        return await commandPromise;
    }

    /*
     * Overridden method
     */
    async generateZip(parameters) {
        this._validateParameters(parameters);
        const worker = await this.workerPromise;

        const [content, FileSaver] = await Promise.all([
            this.postCommandToWorker(worker, "zip", parameters),
            import('file-saver').then(module => module.default)
        ]);
        FileSaver.saveAs(content, `${parameters.name}.zip`);
    }

    /*
     * Overridden method
     */
    async generateCommands(parameters) {
        this._validateParameters(parameters);
        const worker = await this.workerPromise;

        return await this.postCommandToWorker(worker, "commands", parameters);
    }

    /*
     * Overridden method
     */
    async generatePreview(parameters) {
        this._validateParameters(parameters);
        const worker = await this.workerPromise;

        return await this.postCommandToWorker(worker, "preview", parameters);
    }

    /**
     * Overridden method
     */
    async generateDiff(parameters) {
        this._validateParameters(parameters);
        const worker = await this.workerPromise;

        return await this.postCommandToWorker(worker, "diff", parameters);
    }
}

